"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePageMeta = usePageMeta;
var React = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _pageMeta = require("../pageMeta");
/* global window: true */function usePageMeta(pageMeta) {
  var dispatch = (0, _reactRedux.useDispatch)();
  // We use React initial state to dispatch it at mount and before render, just like a componentWillMount.
  // Only the React render top-to-bottom flow is used as priority.
  React.useState(function () {
    if (global.__CLIENT__) {
      dispatch((0, _pageMeta.setPageMeta)({
        // window.location.pathname is only used for debugging purposes
        pathname: window.location.pathname,
        pageMeta: pageMeta
      }));
    }
  });
}